<template>
    <scroll-wrap>
        <div class="main-box">
            <div class="content-wrap">
                <div class="country">
                    <img :src="require(`./../../assets/image/${$store.state.record.country}.png`)" alt="">
                </div>
                <div class="main-area">
                    <div class="title">
                        <span class="zh">
                            中华人民共和国海关出口货物报关单
                        </span>
                    </div>
                    <div class="main-area-box">
                        <div class="title">
                            <div class="tit-item">
                                <span>预录入编号</span>
                                <el-input v-model="preliminary.preEntryNumber" size="mini"></el-input>
                            </div>
                            <div class="tit-item">
                                <span>海关编号</span>
                                <el-input v-model="preliminary.customsNo" size="mini"></el-input>
                            </div>
                        </div>
                        <div class="form-wrap">
                            <div class="item" :style="{width:`${indexWidth[index][0]}%`}"
                                 v-for="(item,key,index) in formData"
                                 :key="index">
                                <label :for="`item-${index}`">{{indexWidth[index][1]}}</label>
                                <el-input
                                        :id="`item-${index}`"
                                        type="textarea"
                                        autosize
                                        v-model="formData[key]">
                                </el-input>
                            </div>
                            <div style="width: 100%;border-right: 1px solid #000000;border-bottom: 1px solid #000000">
                                <el-table
                                        header-row-class-name="head-style"
                                        size="mini"
                                        :data="tableData"
                                        style="width: 100%">
                                    <el-table-column
                                            prop="itemNo"
                                            label="项号"
                                            width="100">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.itemNo" size="mini"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="productCode"
                                            label="商品编号">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.productCode" size="mini"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="title"
                                            label="商品名称、规格型号">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.title" size="mini"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="amount"
                                            label="数量及单位">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.amount" size="mini"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="destCountry"
                                            label="最终目的国（地区）">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.destCountry" size="mini"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="price"
                                            label="单价">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.price" size="mini"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="sumPrice"
                                            label="总价">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.sumPrice" size="mini"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="currency"
                                            label="币制">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.currency" size="mini"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="exemption"
                                            label="征免">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.exemption" size="mini"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            width="60"
                                            align="center"
                                            label="增减">
                                        <template slot-scope="scope">
                                            <div class="handle-wrap">
                                                <i v-if="scope.$index!==0" class="el-icon-remove-outline" @click="handleMinus"></i>
                                                <i class="el-icon-circle-plus-outline" @click="handleAdd(scope.row.$index)"></i>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="foot">
                <span class="btn" v-if="$route.meta.prev" @click="$router.push($route.meta.prev)">
                    上一步
                </span>
                <span class="btn" v-if="$route.meta.next" @click="apply">
                    申请报关
                </span>
            </div>
            <dialogue v-if="dialogueShow" :talk-list-init="talkList" @close="dialogueShow=false"></dialogue>
        </div>
    </scroll-wrap>
</template>

<script>
    import dialogue from '../../components/dialogue'
    export default {
        name: "investigate",
        components: {
            dialogue
        },
        data() {
            return {
                dialogueShow:true,
                list: [
                    'ASpace.png',
                    'BSpace.png'
                ],
                textarea1: '',
                indexWidth: [
                    [36,'出口口岸'], [24,'备案号'],[16,'出口日期'], [24,'申报日期'],
                    [36,'经营单位'], [16,'运输方式'], [16,'运输工具'], [32,'提运单号'],
                    [36,'发货单位'], [24,'贸易方式'], [16,'免征性质'], [24,'结汇方式'],
                    [25,'许可证号'], [25,'抵运国'], [25,'指运港'], [25,'境内货源地'],
                    [25,'批准文号'], [12,'成交方式'], [20,'运费'], [18,'保费'], [25,'杂费'],
                    [25,'合同协议号'], [16,'件数'], [16,'包装种类'], [18,'毛重'], [25,'净重'],
                    [25,'集装箱号'], [50,'随附单据'], [25,'生产厂家'],
                    [100,'标记喷码及备注']
                ],
                tableData: [{
                    itemNo: '',
                    productCode: '',
                    title: '',
                    amount: '',
                    destCountry: '',
                    price: '',
                    sumPrice: '',
                    currency: '',
                    exemption: '',
                }],
                preliminary:{
                    storeExpInId:'',
                    preEntryNumber:'',
                    customsNo:'',
                },
                formData: {
                    exportPort: '',
                    recordNo: '',
                    exportDate: '',
                    declareDate: '',
                    businessUnit: '',
                    shippingType: '',
                    shippingTool: '',
                    shippingNo: '',
                    shippingUnit: '',
                    modeOfTrade: '',
                    natureOfExemption: '',
                    settlementType: '',
                    licenceNo: '',
                    countryOfArrival:'',
                    portOfTransport: '',
                    localGoodsAddress: '',
                    approvalNumber: '',
                    transactionMode: '',
                    freight: '',
                    premium: '',
                    incidental: '',
                    contractAgreementNo: '',
                    amount: '',
                    packagingType: '',
                    grossWeight: '',
                    netWeight: '',
                    containerNumber: '',
                    attachmentSheet: '',
                    manufacturer: '',
                    signAndNote: '',
                }
            }
        },
        computed:{
            talkList(){
                if(this.$store.state.record.country === 'MY'){
                    return [
                        {
                            txt: `在我国，由于真丝及其制品稀缺。因此，真丝及其制品需要申领出口许可证才能出口。是否正确？`,
                            type: 'teacher',
                            options: ["正确","错误"],
                            rightAnswers: '正确答案: 错误。理由：出口许可证管理属于国家限制出口管理范畴，真丝及其制品不属于国家限制出口管理范畴。',
                            answer: '',
                            value: "错误",
                            questionType:'choice',
                            questionIndex:6,
                            score:8,
                        },
                    ]
                }else {
                    return [
                        {
                            txt: `羽绒服出口按照一般进出口货物报关，其报关流程的最后一步是什么？`,
                            type: 'teacher',
                            options: ["A、申报","B、查验","C、征税","D、放行"],
                            rightAnswers: '正确答案: D、放行。一般进出口货物报关放行就等于结关。',
                            answer: '',
                            value: "D、放行",
                            questionType:'choice',
                            questionIndex:6,
                            score:8,
                        },
                    ]
                }

            }
        },
        created() {
            this.axios.post('/student/store/exp/in/declare/get',{
                storeExpInId:this.$store.state.record.store['A仓'].id
            }).then(res=>{
                if(res.login && res.succeed){
                    res.declare.amount = this.$store.state.record.country === 'MY'? 30000 : 6000
                    for(let i in this.formData){
                        this.formData[i] = res.declare[i]
                    }
                    this.tableData = [res.declare.items[0],res.declare.items[0]]
                }
            })
            this.axios.post('/student/store/exp/in/declare/get',{
                storeExpInId:this.$store.state.record.store['B仓'].id
            })
        },
        methods:{
            handleAdd(index){
                this.tableData.splice(index+1,0,{
                    itemNo: '',
                    productCode: '',
                    title: '',
                    amount: '',
                    destCountry: '',
                    price: '',
                    sumPrice: '',
                    currency: '',
                    exemption: '',
                })
            },
            handleMinus(index){
                this.tableData.splice(index,1)
            },
            apply(){
                this.$swal({
                    text:'申请报关成功',
                    icon:'success',
                    confirmButtonText: '下一步'
                }).then(res=>{
                    this.$router.push(this.$route.meta.next)
                });

            }
        }
    }
</script>

<style scoped lang="scss">
    .main-box {
        height: 100%;

        .content-wrap {
            display: flex;
            position: relative;
            min-height: calc(100% - 88px);
            justify-content: flex-start;
            flex-grow: 1;

            .country {
                position: relative;
                width: 364px;
                min-width: 364px;
                flex-shrink: 0;

                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .main-area {
                flex-grow: 1;
                display: flex;
                align-items: center;
                flex-direction: column;
                padding: 30px 60px;
                position: relative;

                div.title {
                    color: #000000;
                    width: 100%;
                    display: flex;
                    justify-content: center;

                    span.zh {
                        font-size: 18px;
                        font-weight: bolder;
                    }

                    span.en {
                        font-size: 12px;
                    }
                }

                .main-area-box {
                    height: 100%;
                    padding: 10px 0;

                    div.title {
                        display: flex;
                        margin-bottom: 10px;
                        div.tit-item {
                            margin-right: 10px;
                            span {
                                word-break: keep-all;
                                margin-right: 10px;
                            }
                            display: flex;
                        }
                    }

                    .form-wrap {
                        width: 1000px;
                        border-left: 1px solid #2c3e50;
                        border-top: 1px solid #2c3e50;
                        display: flex;
                        background: #FFFFFF;
                        flex-wrap: wrap;

                        ::v-deep .el-table thead {
                            color: #2c3e50;
                            font-size: 14px;
                            font-weight: normal!important;
                        }
                        ::v-deep th {
                            font-weight: normal;
                        }

                        .handle-wrap {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 18px;
                            i:hover {
                                cursor: pointer;
                                color: red;
                            }
                        }

                        div.item {
                            border-right: 1px solid #2c3e50;
                            border-bottom: 1px solid #2c3e50;
                            display: flex;
                            flex-direction: column;
                            align-items: flex-start;
                            padding: 6px;
                            flex-grow: 1;

                            label {
                                width: 100%;
                                text-align: left;
                                font-size: 14px;
                                margin-bottom: 4px;
                                cursor: pointer;
                            }

                            ::v-deep textarea {
                                width: 100%;
                                border: none;
                                outline: none;
                                font-size: 14px;
                                resize: none;
                                padding: 0;
                                height: 28px;
                                max-height: 42px;
                            }
                        }
                    }
                    .fo {
                        margin-top: 10px;
                        display: flex;
                        justify-content: center;
                        span {
                            border-radius: 100px;
                            cursor: pointer;
                            padding: 10px 38px;
                            background: #004BFF;
                            color: #FFFFFF;
                            &:hover {
                                background: red;
                            }
                        }
                    }
                }
            }
        }

        > .foot {
            background: #EEEFEF;
            display: flex;
            align-items: center;
            justify-content: center;border-radius:0 0 10px 10px;
            height: 88px;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;

            span.btn {
                cursor: pointer;
                padding: 10px 38px;
                background: #004BFF;
                color: #FFFFFF;
                border-radius: 100px;
                margin-right: 40px;

                &:hover {
                    opacity: 0.8;
                }

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
</style>
